import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

const DEMO_LOADS = [
  { route: "Orlando → Atlanta", status: "Driver Selected · Carrier Authorization Pending" },
  { route: "Tampa → Charlotte", status: "3 Drivers Invited" },
  { route: "Jacksonville → Savannah", status: "Ready for Pickup" },
  { route: "Miami → Orlando", status: "In Transit" },
];

export const BrokerLoadListDemo = () => (
  <section data-testid="broker-load-list-demo-section" className="py-24 md:py-28 bg-rr-surface">
    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Broker Load List" title="Track Every Opportunity in One Place." align="center" testId="broker-load-list-demo" />
      <Reveal delay={0.2}>
        <div data-testid="broker-load-list-demo-card" className="mt-10 bg-white border border-rr-line rounded-2xl p-6 md:p-8">
          <div className="flex items-center justify-between mb-5">
            <h3 className="font-heading font-bold text-rr-navy">Broker Load List</h3>
            <span data-testid="broker-load-list-demo-label" className="text-[11px] font-bold uppercase tracking-wide text-rr-muted bg-rr-surface border border-rr-line rounded-full px-2.5 py-1">Demo Data</span>
          </div>
          <div className="divide-y divide-rr-line">
            {DEMO_LOADS.map((l) => (
              <div key={l.route} data-testid={`broker-load-list-demo-row-${l.route.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-center justify-between py-3.5 first:pt-0 last:pb-0">
                <span className="font-semibold text-rr-navy text-sm">{l.route}</span>
                <span className="text-xs font-bold text-rr-orange">{l.status}</span>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
